<template>
  <div class="salary-container">
    <van-nav-bar
      title="工资条"
      @click-left="$router.push('/')"
      left-arrow
      safe-area-inset-top
      placeholder
    />
    <div class="box_container">
      <block v-if="result.records.length > 0">
        <div
          class="box"
          v-for="(item, index) of result.records"
          :key="index"
        >
          <div class="b_center">
            <div class="b_center_title"><strong>姓名:</strong> {{ item.userName }}</div>
            <div class="b_center_title"><strong>月份:</strong> {{ item.month }}</div>
            <div class="b_center_title"><strong>身份证号:</strong> {{ item.idCard }}</div>
            <div class="b_center_title"><strong>主体公司:</strong> {{ item.storeName }}</div>
            <div class="b_center_title"><strong>基本工资:</strong> {{ item.basicSalary }}</div>
            <div class="b_center_title"><strong>浮动绩效:</strong> {{ item.meritSalary }}</div>
            <div class="b_center_title"><strong>岗位工资:</strong> {{ item.postSalary }}</div>
            <div class="b_center_title"><strong>补贴金额:</strong> {{ item.bonusSalary }}</div>
            <div class="b_center_title"><strong>扣款金额:</strong> {{ item.deductSalary }}</div>
            <div class="b_center_title"><strong>工龄(月):</strong> {{ item.workMonth }}</div>
            <div class="b_center_title"><strong>是否缴纳社保:</strong> {{ item.socialSecurity == 0 ? '否' : item.socialSecurity == 1 ? '是' : '-' }}</div>
            <div class="b_center_title"><strong>小计(A):</strong> {{ item.countA }}</div>
            <div class="b_center_title"><strong>兼职工资:</strong> {{ item.partimeSalary }}</div>
            <div class="b_center_title"><strong>兼职补贴:</strong> {{ item.partimeBonus }}</div>
            <div class="b_center_title"><strong>兼职扣款:</strong> {{ item.partimeDeduct }}</div>
            <div class="b_center_title"><strong>加班工资:</strong> {{ item.extraWorkSalary }}</div>
            <div class="b_center_title"><strong>服务激励:</strong> {{ item.incentiveSalary }}</div>
            <div class="b_center_title"><strong>小计(B):</strong> {{ item.countB }}</div>
            <div class="b_center_title"><strong>住房津贴:</strong> {{ item.housingSubsidy }}</div>
          </div>
        </div>
      </block>
      <van-empty description="暂无工资条数据" v-else />
    </div>
    <div class="page" v-if="result.total > 1">
      <van-pagination
        v-model="currentPage"
        :total-items="result.total"
        :show-page-size="3"
        force-ellipses
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import { salaryList } from "@/api/index";
export default {
  name: "",
  components: {},
  data() {
    return {
      value: "",
      formData: {
        pageSize: 5,
      },
      result: {},
      currentPage: 1,
    };
  },
  created() {
      this.init();
  },
  methods: {
    init() {
      salaryList(this.formData).then((res) => {
        if (res.data.success) {
          this.result = res.data.result;
        }
      });
    },
    change(e) {
      this.formData.pageNo = e;
      this.init();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.salary-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
  min-height: 100vh;
  padding-bottom: 20px;
}

/deep/ .van-nav-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);

  .van-nav-bar__title {
    color: #fff;
    font-weight: 600;
    font-size: 18px;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon {
    color: #fff;
    font-size: 20px;
  }
}

.box_container {
  padding: 16px;
  
  .box {
    background: #ffffff;
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(232, 232, 232, 0.5);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }
    
    &:last-child {
      margin-bottom: 0;
    }

    .b_center {
      .b_center_title {
        color: #333;
        line-height: 1.8;
        padding: 8px 0;
        font-size: 15px;
        border-bottom: 1px solid rgba(232, 232, 232, 0.3);
        
        &:nth-child(odd) {
          background-color: rgba(232, 232, 232, 0.1);
        }
        
        &:nth-child(even) {
          background-color: rgba(245, 247, 250, 0.5);
        }
        
        &:last-child {
          border-bottom: none;
        }
        
        &::before {
          content: "•";
          color: #667eea;
          font-weight: bold;
          display: inline-block;
          width: 20px;
        }
      }
      
      .b_center_title:nth-child(4),
      .b_center_title:nth-child(12),
      .b_center_title:nth-child(17) {
        font-weight: 600;
        color: #667eea;
        background-color: rgba(102, 126, 234, 0.05);
        border-top: 2px solid rgba(102, 126, 234, 0.1);
        border-bottom: 2px solid rgba(102, 126, 234, 0.1);
      }
    }
  }
}

/deep/ .van-empty {
  margin-top: 60px;
  
  .van-empty__description {
    color: #999;
    font-size: 16px;
  }
}

.page {
  padding: 20px 16px;
  background: #fff;
  margin-top: 10px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  /deep/ .van-pagination {
    justify-content: center;
    
    .van-pagination__item {
      background-color: #f5f7fa;
      border: 1px solid #e4edf5;
      color: #667eea;
      font-weight: 500;
      
      &.van-pagination__item--active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-color: #667eea;
      }
    }
  }
}

// 移动端适配
@media (max-width: 768px) {
  .box_container {
    padding: 12px;
    
    .box {
      padding: 16px;
      margin-bottom: 12px;
      border-radius: 12px;
      
      .b_center {
        .b_center_title {
          font-size: 14px;
          padding: 6px 0;
          line-height: 1.6;
        }
      }
    }
  }
  
  .page {
    padding: 16px 12px;
  }
}

// 加载动画
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.box {
  animation: fadeIn 0.3s ease-out;
}
</style>